var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion-container"},[_vm._l((_vm.accordion),function(accItem,index){return [_c('AccordionItem',{key:index,attrs:{"accKey":index,"title":accItem.title,"body":accItem.body,"image":accItem.file_id,"opened":index === _vm.openedIndex},on:{"openedItem":_vm.openedItem}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }